import { render, staticRenderFns } from "./ProfileDialogComponent.vue?vue&type=template&id=1a3f4bfd&scoped=true"
import script from "./ProfileDialogComponent.js?vue&type=script&lang=js&external"
export * from "./ProfileDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./ProfileDialogComponent.vue?vue&type=style&index=0&id=1a3f4bfd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f4bfd",
  null
  
)

export default component.exports